<template>
  <div id="axios-interceptors" />
</template>

<script>
export default {
  name: "AxiosInterceptors",
  mounted() {
    this.$axios.interceptors.response.use((response) => {
      this.handleResponse(response)

      return response
    }, (error) => {
      this.handleResponse(error.response)

      return Promise.reject(error)
    })
  },
  methods: {
    handleResponse (response) {
      if (!response) {
        return
      }

      function handleValidationErrors (response) {
        if (!response.data) {
          return null
        }

        // Attempt to parse Laravel-structured validation errors.
        try {
          let messages = {}

          for (var key in response.data.errors) {
            messages[key] = response.data.errors[key].join("\n")
          }

          return messages
        } catch (e) {
          return response.data
        }
      }

      // var categories = ['informational', 'success', 'redirection', 'client-error', 'server-error']
      let status = response.status

      // var statusCategory = parseInt(status.toString().charAt(0))
      // var category = categories[statusCategory - 1]
      // var sluggedCode = slugify(codes[status])
      let data = { status: status, code: status, body: response.data }

      // Parse the validation errors.
      if (parseInt(status) === 422) {
        data.body = handleValidationErrors(response)
      }

      let location = window.location.href
      let pathname = window.location.hash ? window.location.hash.replace('#', '') : window.location.pathname;
      let doNotRedirectUrls = ['/login', '/register', '/reset_password', '/forgot_password']

      let redirect = true

      for(let path of doNotRedirectUrls){
        if(location.indexOf(path) > -1){
          redirect = false
          break
        }
      }

      // if (status === 401) {
      //   this.$store.commit('mainStore/user', {});
      //   return this.$router.replace('/login')
      // }

      if (status === 401 && ['/login', '/signup', '/forgot_password', '/reset_password', '/logout'].indexOf(pathname) === -1) {
        return this.$q.notify({
          message: 'This functionality requires account. Please login or sign up.',
          closeBtn: '',
          type: 'negative',
          actions: [{
            label: 'Ok',
            color: 'white',
            handler: () => {
              this.$router.replace('/login')
            }
          }]
        })
      }

      // access denied
      if (status === 403 && ['/dashboard'].indexOf(pathname) === -1) {
        this.$router.replace('/dashboard')
      }

      // login failed
      if (status === 406) {
        return this.notifyError(data.body.error || data.error)
      }

      // custom error message
      if (status === 411) {
        return this.notifyError(data.body.message || data.error)
      }

      // subscription error, go to billing
      if (status === 430) {
        return cordova.InAppBrowser.open(this.$apiUrl.replace('/api', '/billing'), '_system');
      }

      // user is not approved
      if (status === 410 && ['/waiting_for_verification'].indexOf(pathname) === -1) {
        return this.$router.replace('/waiting_for_verification')
      }

      // validation errors
      if (status === 422) {
        let validationErrors = data.body
        let field
        let error = ''

        for (field in validationErrors) {
          error += field + ': ' + validationErrors[field] + '\n'
        }

        return this.notifyError(error)
      }

      // server errors
      if (status === 500) {
        let error = data.body.message

        if (data.body.file) {
          error += ' on ' + data.body.file + ':' + data.body.line
        }

        return this.notifyError(error)
      }

      return true
    },

    notifyError (error) {
      this.$q.notify({
        message: `<pre>${error}</pre>`,
        html: true,
        type: 'negative',
        // color: 'danger'
      })
    }
  }
}
</script>

<style scoped>

</style>
